import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Motion";
import { EASE } from "../../lib/site";

const STEPS = [
  { img: "/img/step1.webp", title: "Antes do laser", text: "O pelo nasce forte e visível.", alt: "Ilustração da pele com um pelo escuro e forte crescendo do folículo" },
  { img: "/img/step2.webp", title: "Durante o laser", text: "A luz do laser é absorvida pela melanina do pelo, atingindo a raiz.", alt: "Ilustração do feixe de laser atingindo a raiz do pelo" },
  { img: "/img/step3.webp", title: "Após o laser", text: "O pelo enfraquece e cai naturalmente.", alt: "Ilustração do pelo enfraquecido se soltando do folículo" },
  { img: "/img/step4.webp", title: "Resultado", text: "Com as sessões, os pelos nascem cada vez mais finos e em menor quantidade, até a redução permanente.", alt: "Ilustração da pele lisa com apenas um pelo fino e claro" },
];

const Step = ({ s, i }) => (
  <Reveal as="li" delay={0.12 * i} className="group relative" data-testid={`process-step-${i + 1}`}>
    <div className="relative aspect-[4/3] overflow-hidden rounded-[1.5rem] bg-[#F3E8DC] ring-1 ring-[#B8654F]/15">
      <img src={s.img} alt={s.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-110" />
    </div>
    <span className="absolute -top-4 left-5 grid h-12 w-12 place-items-center rounded-full bg-gradient-to-b from-[#B8654F] to-[#7F3628] font-display text-lg text-[#FAF5EE] shadow-lg ring-4 ring-[#FAF5EE]">
      {i + 1}
    </span>
    <h3 className="mt-6 font-display text-xl uppercase tracking-tight text-[#2D1C18]">{s.title}</h3>
    <p className="mt-2 max-w-xs text-[0.95rem] leading-relaxed text-[#6B5650]">{s.text}</p>
  </Reveal>
);

export const Process = () => (
  <section id="como-funciona" className="relative overflow-hidden bg-[#F3E8DC] py-24 sm:py-32" aria-labelledby="processo-title" data-testid="process-section">
    <img src="/img/satin.webp" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-25" loading="lazy" />
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <Reveal>
        <Eyebrow className="text-[#9A4A38]">Passo a passo</Eyebrow>
        <h2 id="processo-title" className="section-title mt-4 max-w-4xl">
          Como <span className="text-metal">funciona</span> o processo dos pelos?
        </h2>
      </Reveal>
      <motion.div
        className="mt-16 hidden h-px origin-left bg-gradient-to-r from-[#B8654F] via-[#E4A08B] to-transparent lg:block"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 1.8, ease: EASE }}
        aria-hidden="true"
      />
      <ol className="mt-14 grid gap-x-6 gap-y-14 sm:grid-cols-2 lg:mt-12 lg:grid-cols-4">
        {STEPS.map((s, i) => <Step key={s.title} s={s} i={i} />)}
      </ol>
    </div>
  </section>
);
